import React from 'react';
import { Loader2 } from 'lucide-react';

interface NotionToggleProps {
  enabled: boolean;
  loading?: boolean;
  onClick: () => void;
  disabled?: boolean;
  size?: 'sm' | 'md';
}

export function NotionToggle({
  enabled,
  loading = false,
  onClick,
  disabled = false,
  size = 'md'
}: NotionToggleProps) {
  const sizeClasses = size === 'sm' ? 'w-9 h-5' : 'w-11 h-6';
  const dotSizeClasses = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5';
  const translateClasses = size === 'sm' ? 'translate-x-4' : 'translate-x-5';

  if (loading) {
    return (
      <div className={`${sizeClasses} flex items-center justify-center`}>
        <Loader2 className="h-4 w-4 animate-spin text-[#787774]" />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`
        relative ${sizeClasses} rounded-full transition-colors duration-200 ease-in-out
        ${disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}
        ${enabled ? 'bg-green-500 dark:bg-green-600' : 'bg-gray-200 dark:bg-gray-600'}
      `}
      role="switch"
      aria-checked={enabled}
    >
      <span
        className={`
          absolute top-0.5 left-0.5 ${dotSizeClasses} rounded-full bg-white shadow-sm
          transition-transform duration-200 ease-in-out
          ${enabled ? translateClasses : 'translate-x-0'}
        `}
      />
    </button>
  );
}

export default NotionToggle;
